export const FETCH_SCORES_REQUEST = "FETCH_SCORES_REQUEST";
export const FETCH_SCORES_SUCCESS = "FETCH_SCORES_SUCCESS";
export const FETCH_SCORES_FAILURE = "FETCH_SCORES_FAILURE";

export const SAVE_SCORE_REQUEST = "SAVE_SCORE_REQUEST";
export const SAVE_SCORE_SUCCESS = "SAVE_SCORE_SUCCESS";
export const SAVE_SCORE_FAILURE = "SAVE_SCORE_FAILURE";

export const CHANGE_SCORE_STATUS_REQUEST = "CHANGE_SCORE_STATUS_REQUEST";
export const CHANGE_SCORE_STATUS_SUCCESS = "CHANGE_SCORE_STATUS_SUCCESS";
export const CHANGE_SCORE_STATUS_FAILURE = "CHANGE_SCORE_STATUS_FAILURE";
